export const HISTORY_METHOD_CALLED = 'HISTORY_METHOD_CALLED';
const createAction = method => location => ({
  type: HISTORY_METHOD_CALLED,
  payload: {
    method,
    args: [location]
  }
});
export const push = createAction('push');